/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { ICustomTheme } from 'interfaces';
import { getSelectedProducts } from '../utils';
import { StepsType, IForm } from '../interfaces';
import { STEPS } from '../constants';
import { NavButtons } from './NavButtons';
import { NbOfResultsChip } from './NbOfResultsChip';
import { StyledContainer } from './styles';
import {
  StyledArrowUpIcon,
  StyledSecondaryNavButton,
} from './NavButtons/styles';

export default function DeclarationNavigation({
  step,
  scrollTop,
}: {
  step: StepsType;
  scrollTop?: () => void;
}): JSX.Element {
  const { values } = useFormikContext<IForm>();
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const selectedProducts = getSelectedProducts(values[STEPS.products]);

  return (
    <StyledContainer isMobile={isMobile}>
      {isMobile && (step === STEPS.products || step === STEPS.summary) && (
        <StyledSecondaryNavButton
          onClick={scrollTop}
          variant="contained"
          type="button"
          disableElevation
          backgroundColor={theme.colors.paletteFromBO.main}
          isMobile={isMobile}
        >
          <StyledArrowUpIcon />
        </StyledSecondaryNavButton>
      )}
      {isMobile && <NbOfResultsChip selectedProducts={selectedProducts} />}
      <NavButtons
        step={step}
        selectedProducts={selectedProducts}
        scrollTop={scrollTop}
      />
      {!isMobile && <NbOfResultsChip selectedProducts={selectedProducts} />}
      {!isMobile && (step === STEPS.products || step === STEPS.summary) && (
        <StyledSecondaryNavButton
          onClick={scrollTop}
          variant="contained"
          type="button"
          disableElevation
          backgroundColor={theme.colors.paletteFromBO.main}
          isMobile={isMobile}
        >
          <StyledArrowUpIcon />
        </StyledSecondaryNavButton>
      )}
    </StyledContainer>
  );
}
